import _get from 'lodash/get';

import { Base, Inspector } from '@/models';
import { omitDeep, toCamelCase } from '@/utilities';

export class InspectorFee extends Base {

  public id: Inspector;
  public notes: string;
  public photos: string[];

  /**
   * Constructor initialises the variables from the class Job
   * @param data - the data to construct a type with all properties of <Job>
   */
  public constructor(data?: Partial<InspectorFee>) {
    super(data);
    data = toCamelCase(data);
    this.id = new Inspector(_get(data, 'id'));
    this.notes = _get(data, 'notes', '');
    this.photos = _get(data, 'photos', []);
  }

  /**
  * Convert class instance back into a plain old JSON object
  * and recursively remove all uuids we've add for Vue.
  *
  * @return {Object}
  */
  public toObject() {
    return omitDeep({ ...this }, ['_uuid']);
  }

  /**
  * Create a JSON representation of this object and it's descedents.
  *
  * @return {Object}
  */
  public toJSON() {
    const json = super.toJSON();
    // Convert the populated Client to the Client ID
    // Convert the populated Client to the Client ID and handle fees conversion
    return {
      ...json,
      id: this.id?.id,
    };
  }
}
